import api, { METHODS } from './api'
import { CronNextExecutionResponse } from '../common/types/api/cronNextExecution'

export default async function getCronNextExecution(cron: string): Promise<CronNextExecutionResponse> {
    try {
        const requestCronNextExecution = await api<CronNextExecutionResponse>(
            `getCronNextExecution/${encodeURIComponent(cron).replace('%2F', '%252F')}`, // for apache servers
            METHODS.GET
        )

        if (!requestCronNextExecution.success) {
            // TODO: use logger
            // console.error(requestCronNextExecution.error)
        }

        return requestCronNextExecution
    } catch (error) {
        // TODO: use logger
        // console.error(error)

        return null
    }
}
